<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" ref="modal">     
        <div class="u-window m-msg-modal">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper">
                <div class="dialog-body">
                    <div class="dialog-text">
                        确认加入<b>【{{ name }}】</b>的队伍吗？
                    </div>

                    <div class="u-btn ok" @click="apply"></div>
                </div>   
            </div>         
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>      
</template>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            name : '',
            code : '',
        }
    }, 
    methods : {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        apply (){
            this.$axios.post(ajax_url_map.accept,this.$qs.stringify({
                key : this.code,
            }))
            .then(
                res => {
                    this.destroyElement();
                    this.$msgs_modal({text : '你的入队申请已提交给队长，请耐心等待。'})
                },
                rej => {
                    this.destroyElement();
                    this.$msgs_modal({text : rej.message})
                }
            );
        },                 
    },
}
</script>

<style scoped>
/* share */
.m-msg-modal {
    width: 504px;
    height: 304px;
    background-image: url(~@/assets/images/utils/bg-modal-smsg.png);
}

.dialog-wrapper{
    padding: 50px 40px 0;
}

.dialog-text {
    font-size: 22px;
    color: #a1837d;
    text-align: center;
    word-break: break-all;
}

.dialog-text p{
    color: #715835;
    text-align: center;    
    margin-bottom: 4px;
}

.dialog-text b{
    color: #d45c3d;
}

.u-btn.ok {
    position: absolute;
    left: 50%;
    bottom: 35px;
    width: 240px;
    height: 80px;
    margin-left: -120px;
    background-image: url(~@/assets/images/utils/btn-ok.png);
}
</style>


// WEBPACK FOOTER //
// src/components/Comfirm/msgModal.vue